const addToBuylistCart = (localStorage, product) => {
  let c = localStorage.get('buylistProducts');
  if (!c) {
    localStorage.set('buylistProducts', []);
    c = [];
  }
  const i = c.findIndex(l => l.uuid === product.uuid);
  if (i >= 0) {
    c[i].quantity += product.quantity;
  } else {
    c.push(product);
  }
  localStorage.set('buylistProducts', c);
};

export default addToBuylistCart;



// WEBPACK FOOTER //
// ./src/addToBuylistCart.js